// extracted by mini-css-extract-plugin
module.exports = {"Table":"PowerGrid_Table__1CcUx","KendoGrid":"PowerGrid_KendoGrid__2vQvX"};